import { render, staticRenderFns } from "./MissingGaurdianPopup.vue?vue&type=template&id=933ef560&scoped=true&"
import script from "./MissingGaurdianPopup.vue?vue&type=script&lang=ts&"
export * from "./MissingGaurdianPopup.vue?vue&type=script&lang=ts&"
import style0 from "./MissingGaurdianPopup.less?vue&type=style&index=0&id=933ef560&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "933ef560",
  null
  
)

export default component.exports